import { render, staticRenderFns } from "./zrsy2.vue?vue&type=template&id=5b9f08a6&scoped=true"
import script from "./zrsy2.vue?vue&type=script&lang=js"
export * from "./zrsy2.vue?vue&type=script&lang=js"
import style0 from "./zrsy2.vue?vue&type=style&index=0&id=5b9f08a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f08a6",
  null
  
)

export default component.exports